import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { SeoProvider } from "@/components/Seo";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// The static prerender (scripts/prerender.js) bakes per-route title, meta
// description, keywords, canonical, and OG tags into every built HTML file so
// crawlers see them without JavaScript. Once the app boots, react-helmet-async
// takes over head management — so strip the build-time tags first, otherwise
// every page would render duplicate title/meta/canonical elements.
document.head
  .querySelectorAll(
    'title, meta[name="description"], meta[name="keywords"], link[rel="canonical"], meta[property="og:title"], meta[property="og:description"], meta[property="og:url"]'
  )
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SeoProvider>
        <App />
      </SeoProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
